import {taskDay} from './taskDates';
export function taskTomorrow(due,current=new Date()) {
 const day=taskDay(current);
 if(day===null)throw new Error('Huomisen päivää ei voitu varmistaa.');
 const date=new Date(day+86400000).toISOString().slice(0,10);
 if(!due||/^\d{4}-\d{2}-\d{2}$/.test(due))return {due:date,label:date.split('-').reverse().join('.'),day:date};
 if(typeof due!=='string'||!/(?:Z|[+-]\d{2}:\d{2})$/.test(due)||!Number.isFinite(Date.parse(due)))throw new Error('Tarkista tehtävän kellonaika ensin Muokkaa-toiminnolla.');
 const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Helsinki',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date(due));
 const value=key=>parts.find(p=>p.type===key).value;
 const clock=`${value('hour')}:${value('minute')}:${value('second')}`;
 // A timezone-less task input is interpreted and DST-validated in Helsinki by
 // the existing server task validator. Never reuse yesterday's UTC offset.
 return {due:`${date}T${clock}`,label:`${date.split('-').reverse().join('.')} klo ${clock.slice(0,5).replace(':','.')} (Suomen aika)`,day:date};
}
